import React, { ComponentProps } from 'react';
import { asWidgetProps } from 'Src/types/widget-helpers';
import { classnames } from 'Utils/classnames/classnames.utils';
import { t } from 'Src/i18n';
import { Text } from 'Components/frameworks/text/Text';
import { Title } from 'Components/frameworks/title/Title';
import { ActivitiesCategories } from 'Components/widgets/activities-categories/ActivitiesCategories';
import { AvailabilityBadge } from 'Components/widgets/availability-badge/AvailabilityBadge';
type Props = {
  className?: string;
  categories: Array<ActivitiesCategoryEntity>;
  productName: string;
};
export const ProductActivitiesCategories = ({ className, categories, productName }: Props) => (
  <div className={classnames('flex flex-col gap-20 md:flex-row', className)}>
    <div
      className="animation-duration-750 relative isolate animate-fadeIn md:w-1/3"
      data-testid="Activities-aside"
    >
      <div className="absolute -z-1 -mt-40 hidden -translate-x-1/2 transform md:flex rtl:left-full">
        <div className="relative left-[30px] right-[30px] z-1 rounded-full border-5 border-white bg-white">
          <AvailabilityBadge
            {...asWidgetProps<ComponentProps<typeof AvailabilityBadge>>({
              className: 'border-pearl bg-pearl',
              iconSize: '4.375rem',
              isOnDemand: true,
              size: '9.375rem',
            })}
          />
        </div>
        <div className="relative rounded-full border-5 border-white">
          <AvailabilityBadge
            {...asWidgetProps<ComponentProps<typeof AvailabilityBadge>>({
              className: 'border-pearl bg-pearl',
              iconSize: '4.375rem',
              size: '9.375rem',
            })}
          />
        </div>
      </div>
      <p className="mb-10 text-16 text-mediumGrey" data-testid="Activites-title">
        {t('common.activities.allActivitiesInResort', {
          productName,
        })}
      </p>
      <Title
        {...asWidgetProps<ComponentProps<typeof Title>>({
          className: 'mb-20',
          theme: 'title-brand-n44',
        })}
      >
        {t('common.activities.slogan')}
      </Title>
      <Title
        {...asWidgetProps<ComponentProps<typeof Title>>({
          className: 'mb-10',
          theme: 'title-brand-n3',
        })}
      >
        {t('common.activities.catchline')}
      </Title>
      <Text
        {...asWidgetProps<ComponentProps<typeof Text>>({
          className: 'custom-activies-presentation pe-10',
          text: t('common.activities.presentation', {
            includedCount: t('common.activities.includedCount', {
              count: categories.reduce((acc, c) => acc + c.activitiesCounters.included, 0),
            }),
            onDemandCount: t('common.activities.onDemandCount', {
              count: categories.reduce((acc, c) => acc + c.activitiesCounters.onDemand, 0),
            }),
          }),
          theme: 'text-sans-n3',
        })}
      />
    </div>
    <div className="md:w-2/3" data-testid="Activities-components">
      <ActivitiesCategories
        {...asWidgetProps<ComponentProps<typeof ActivitiesCategories>>({
          categories: categories,
          hasCounters: true,
        })}
      />
    </div>
  </div>
);
